import { sessionStorage } from 'dibs-browser-storage';

/**
 * Sets a matchmakerReferrer to a session storage on "Designer Connection" link click.
 */
export function setMatchmakerReferrer(label: string): void {
    sessionStorage.setItem('matchmakerReferrer', label);
}

/**
 * Returns a matchmakerReferrer.
 */
export function getMatchmakerReferrer(): JsonType {
    return sessionStorage.getItem('matchmakerReferrer');
}

/**
 * Removes a matchmakerReferrer from the session storage.
 */
export function deleteMatchmakerReferrer(): void {
    sessionStorage.deleteItem('matchmakerReferrer');
}
